import React, { useMemo, useCallback, useState, useEffect } from 'react';
import { useDropzone } from 'react-dropzone';
import axios from 'axios';
import faker from 'faker';
import { Typography, Grid, Button, FormControl, Select, MenuItem, Box } from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import moment from 'moment';
import { firebaseStore } from '../../storage/base';
import { baseUrl } from '../../utils/constants';
import { useClaimsContext } from '../../context/claims_context';
import { useClientContext } from '../../context/client_context';
import Controls from '../controls/Controls';

const baseStyle = {
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: '20px',
  borderWidth: 2,
  borderRadius: 2,
  borderColor: '#eeeeee',
  borderStyle: 'dashed',
  backgroundColor: '#fafafa',
  color: '#bdbdbd',
  outline: 'none',
  transition: 'border .24s ease-in-out'
};

const activeStyle = {
  borderColor: '#2196f3'
};

const acceptStyle = {
  borderColor: '#00e676'
};

const rejectStyle = {
  borderColor: '#ff1744'
};

export default function ClaimsDocsUpdate(props) {
  const userRefId = sessionStorage.getItem('userRefId');
  const { closePopup, claimIds, clientRefId, documentRefId } = props;
  const { claimNo, populateClaimDocuments } = useClaimsContext();
  //   const { currentDocument, getDocumentByRefId } = useClientContext();
  const [currentDocument, setCurrentDoc] = useState();
  console.log(
    'claimId: ',
    claimIds,
    ' clientRefId:',
    clientRefId,
    ' documentrefId: ',
    documentRefId
  );
  const [progres, setProgress] = useState(0);
  const maxCount = 20;
  const [show, setShow] = useState(false);
  const [docType, setDocType] = useState(0);
  const currDate = moment().format('YYYY-MM-DD h:mm:ss');
  const [notify, setNotify] = useState({ isOpen: false, message: '', type: 'success' });

  useEffect(() => {
    getDocumentByRefId(documentRefId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //   useEffect(() => {
  //     // eslint-disable-next-line react-hooks/exhaustive-deps
  //   }, [currentDocument]);

  console.log('current document', currentDocument);

  // const saveToDatabase = (e) => {
  //   const jsonDoc = [];
  //   jsonDoc.push(e);

  //   console.log('document id stringified now', JSON.stringify(jsonDoc));
  //   fetch(`${baseUrl}/api/client/UpdateDocument`, {
  //     method: 'POST',
  //     headers: {
  //       Accept: 'application/json',
  //       'Content-Type': 'application/json'
  //     },
  //     body: JSON.stringify(jsonDoc[0])
  //   })
  //     .then((res) => res.json())
  //     .then(
  //       (result) => {
  //         console.log('document result after save', result);
  //         populateClaimDocuments(claimNo);
  //         closePopup();
  //       },
  //       (error) => {
  //         <Alert variant="filled" severity="error">
  //           Error in Saving Document!, {error}
  //         </Alert>;
  //       }
  //     );
  // };

  // //   const handleSaveFiles = async (e, i) => {
  // //     const doc = JSON.parse(sessionStorage.getItem('currDoc'));
  // //     console.log('currentDocument here forwethu', doc);
  // //     console.log('currentDocument here i: ', documentRefId);

  // //     doc.DocumentPath = '1234567788a';
  // //     doc.OriginalFileName = 'aasdfghhjjjk';
  // //     doc.DocumentFilename = 'fileNimo';
  // //     handleSaveFiles22(doc);
  // //   };

  // //   const handleSaveFiles22 = (e) => {
  // //     console.log('current Doc here 2nd', e);
  // //   };

  // const handleSaveFile = (e) => {
  //   const doc = JSON.parse(sessionStorage.getItem('currDoc'));
  //   setShow(true);
  //   const file = e;
  //   const fileNimo = `${clientRefId}_${faker.datatype.uuid()}_${file[0].name}`;
  //   console.log('original file name', fileNimo);
  //   const storageRef = firebaseStore.storage().ref();
  //   const uploadTask = storageRef.child(`Claims/${fileNimo}`).put(file[0]);
  //   uploadTask.on(
  //     'state_changed',
  //     (snapshot) => {
  //       const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
  //       setProgress(progress);
  //       console.log(`Upload is ${progress}% done`);
  //     },
  //     (error) => {
  //       alert('failed saving file to storage', error);
  //     },
  //     () => {
  //       uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
  //         doc.DocumentPath = downloadURL;
  //         doc.OriginalFileName = file[0].name;
  //         doc.DocumentFilename = fileNimo;
  //         saveToDatabase(doc);
  //       });
  //     }
  //   );
  // };

  const handleDocumentUploadUpdate = (e) => {
    setShow(true);
    progressCount();
    const formData = new FormData();
    const file = e;
    const fileNimo = clientRefId + file[0].name;
    formData.append('originalFileName', fileNimo);
    formData.append('documentType', 0); // currentDocumentType.toString());
    formData.append('ownerIdentifier', clientRefId);
    formData.append('uploadedByUserRefId', userRefId);
    formData.append('docRefId', documentRefId);
    formData.append('claimRefId', claimIds);
    formData.append('dependantRefId', 0);
    formData.append('dataFile', file[0]);

    console.log('form data', [...formData]);
    const config = {
      headers: {
        'content-type': 'multipart/form-data'
      }
    };
    axios
      .post(`${baseUrl}/api/FileUpload/UploadFiles`, formData, config)
      .then((response) => {
        populateClaimDocuments(claimNo);
        notifyPopup('Document saved successfully...', 'success');
        console.log(response);
      })
      .catch((error) => {
        console.log(error);
        console.log(JSON.stringify(error.response.data.errors));
      });
  };

  const onDrop = useCallback((acceptedFiles) => {
    handleDocumentUploadUpdate(acceptedFiles);
  }, []);

  const {
    getRootProps,
    getInputProps,
    isDragActive,
    isDragAccept,
    isDragReject,
    acceptedFiles,
    openDialog
  } = useDropzone({ onDrop, accept: ['image/*', 'video/*', '.pdf'] });

  const style = useMemo(
    () => ({
      ...baseStyle,
      ...(isDragActive ? activeStyle : {}),
      ...(isDragAccept ? acceptStyle : {}),
      ...(isDragReject ? rejectStyle : {})
    }),
    [isDragActive, isDragReject, isDragAccept]
  );

  const fileNames = acceptedFiles.map((file) => <li key={file.path}>{file.path} bytes</li>);

  const fileSizes = acceptedFiles.map((file) => <li key={file.path}>{file.size} bytes</li>);

  const handleChange = (e) => {
    e.preventDefault();
    setDocType(e.target.value);
    currentDocument.documentType = e.target.value;
  };

  const getDocumentByRefId = async (refId) => {
    console.log('regRefId refId', refId);
    await fetch(`${baseUrl}/api/client/getDocumentByRefId?refId=${refId}`)
      .then((res) => res.json())
      .then(
        (result) => {
          console.log('returned getDocumentByRefId 11111', result.result);
          setCurrentDoc(result.result);
          sessionStorage.setItem('currDoc', JSON.stringify(result.result));
        },
        (error) => {
          alert('failed');
        }
      );
  };

  const progressCount = () => {
    let timer;
    if (progres < maxCount) {
      timer = setInterval(() => {
        setProgress((prevCount) => prevCount + 1);
      }, 1000); // Update every 1 second
    } else {
      clearInterval(timer); // Stop the timer when maxCount is reached
    }
  };

  const notifyPopup = (notifyMessage, notifyType) => {
    setNotify({
      isOpen: true,
      message: `${notifyMessage}`,
      type: `${notifyType}`
    });
  };

  return (
    <>
      {/* <FormControl disabled>
        <Select
          labelId="document-label"
          id="documentType"
          displayEmpty
          value={currentDocument.DocumentType}
          onChange={handleChange}
          size="small"
        >
          <MenuItem value={0} disabled>
            Select Document Type
          </MenuItem>
          <MenuItem value={1}>Member ID Document</MenuItem>
          <MenuItem value={2}>Payslip</MenuItem>
          <MenuItem value={23}>Retirement Letter</MenuItem>
          <MenuItem value={34}>Birth/Marriage Doc</MenuItem>
          <MenuItem value={35}>Proof of Death</MenuItem>
          <MenuItem value={36}>Claimant ID</MenuItem>
        </Select>
      </FormControl> */}
      <div className="container" style={{ marginBottom: 15 }}>
        <div {...getRootProps({ style })}>
          <input {...getInputProps()} />
          <p>Drag 'n' drop some files here, or click to select files</p>
          <button type="button" onClick={openDialog}>
            Open File Dialog
          </button>
        </div>
        <Box sx={{ width: '100%' }}>
          <Controls.LinearProgressWithLabel value={progres} />
        </Box>
        {show && (
          <div>
            <Typography variant="subtitle1" gutterBottom>
              <b>Uploading Files</b>
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <Typography variant="body2" gutterBottom>
                  <b>Name</b> {fileNames}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={1.5}>
                <Typography variant="body2" gutterBottom>
                  <b>Progress</b> <li> {progres} %</li>
                </Typography>
              </Grid>
              <Grid item xs={12} sm={2}>
                <Typography variant="body2" gutterBottom>
                  <b>File size</b> {fileSizes}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={1}>
                <Button variant="contained" color="secondary" onClick={setShow(false)}>
                  Done
                </Button>
              </Grid>
              <Grid item xs={12} sm={1}>
                <Button variant="contained" color="primary">
                  Remove
                </Button>
              </Grid>
            </Grid>
            <Controls.Notification notify={notify} setNotify={setNotify} />
          </div>
        )}
      </div>
    </>
  );
}
